import React, { Component } from 'react';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import SimpleReactValidator from 'simple-react-validator';
import { fetch_login } from '../actions/fetch_login';
import '../styles/login.css';
import Cookies from 'universal-cookie';
import Recaptcha from 'react-recaptcha';
import LoadingBoxes from '../components/loadingBoxes';
import LoadingText from '../components/loadingText';

let cookies = new Cookies();

class Login extends Component {
	constructor(props){
		super(props)
		this.validator = new SimpleReactValidator()
		this.state = {
		  userEmail: '',
		  userPassword: '',
		  recaptcha:'',
		  skip:''
		}
		this.submitForm = this.submitForm.bind(this)
		this.showErrorMessage = this.showErrorMessage.bind(this)
		this.verifyCallback = this.verifyCallback.bind(this)
		this.expiredCallback = this.expiredCallback.bind(this)

    	this.checkLoginState = this.checkLoginState.bind(this);
        this.handleClick = this.handleClick.bind(this);
    	this.getFbUserInfo = this.getFbUserInfo.bind(this);
        this.statusChangeCallback = this.statusChangeCallback.bind(this);   
        this.handleLogout = this.handleLogout.bind(this);
        this.handleSkip = this.handleSkip.bind(this);   
	}
	componentWillMount() {
		const script = document.createElement("script");

		script.src = "https://www.google.com/recaptcha/api.js?hl=zh-TW";
		script.async = true;

		document.body.appendChild(script);

	}
	componentDidUpdate(prev,next){
		/*if (this.props.login.status_code === 200 && !cookies.get('token') && !cookies.get('recordFids')) {
			cookies.set('token', this.props.login.token , { path: '/' , maxAge: 86400});
			cookies.set('recordFids', this.props.login.fids , { path: '/' , maxAge: 86400});
			browserHistory.push('/')
		}*/

		if (this.props.login.message === 'login success' && !cookies.get('token') ) {
			cookies.set('token', this.props.login.token , { path: '/' , maxAge: 86400});
			cookies.set('user_id', this.props.login.data.user_id , { path: '/' , maxAge: 86400})
			browserHistory.push('/')
		}

		// if (this.state.skip!=='' && !cookies.get('token') && !cookies.get('recordFids')) {
		// 	browserHistory.push('/')
		// }
	}
	submitForm() {
		let loginUrl

		if( this.validator.allValid() ){
			//loginUrl = `/login?email=${this.state.userEmail}&password=${this.state.userPassword}&recaptcha=${this.state.recaptcha}`
			loginUrl = {email: `${this.state.userEmail}`,password: `${this.state.userPassword}`};
			
			this.props.fetch_login(loginUrl)
		} else {
			this.validator.showMessages();
			this.forceUpdate();
		}
	}
	handleUserInput (e) {
		let name = e.target.name;
		let value = e.target.value;
		this.setState({[name]: value});
	}
	showErrorMessage(error) {
		let errMsg = ''

		if (error !== false){
			switch(error.data.message) {
			  case 'this account is expired':
			    errMsg = '帳號已過期，請聯絡客服'
			    break;
			  default:
			    errMsg = '信箱或密碼錯誤'
			}
			setTimeout(function(){ location.reload(); }, 3000);
			return <p className="loginFailMsg">{errMsg}</p>
		}
	}
	callback(value) {}
	verifyCallback(response) {
		this.setState({recaptcha:response})
	}
	expiredCallback() {
		this.setState({recaptcha:''})
	}

	componentDidMount(){}

	componentWillUnmount() {}

	checkLoginState(){
		window.FB.getLoginStatus(function(response) {
			this.statusChangeCallback(response);
		}.bind(this));
	}

	statusChangeCallback(response) {

		if (response.status === 'connected') {
			// Logged into your app and Facebook.
			this.getFbUserInfo(response.authResponse);
		} else if (response.status === 'not_authorized') {
			// The person is logged into Facebook, but not your app.
			document.getElementById('status').innerHTML = 'Please log ' +
			  'into this app.';
		} else {
			// The person is not logged into Facebook, so we're not sure if
			// they are logged into this app or not.
			document.getElementById('status').innerHTML = 'Please log ' +
			'into Facebook.';
		}
	}

	getFbUserInfo(response) {
		let fbLoginUrl = `/fb_login?fb_id=${response.userID}&access_token=${response.accessToken}`
		this.props.fetch_login(fbLoginUrl)
	}

	handleClick(){
	 	window.FB.login(this.checkLoginState);
	}

	handleLogout(){
		window.FB.logout(this.checkLoginState);
	}

	handleSkip(){
		this.setState({skip:'fuck'})
		cookies.set('token', '11111' , { path: '/' , maxAge: 86400});
		cookies.set('recordFids', '22222' , { path: '/' , maxAge: 86400});
	}

	render() {
		const {bgSetting,login,login_isloading,login_error} = this.props;

		if (cookies.get('token')) {
		    browserHistory.push('/')
		}

		if (login_isloading){
			return(
			  <div>
			    <LoadingBoxes /> 
			    <LoadingText /> 
			  </div>
			)
		}

		return(
			<div className="loginContainer">
				<div className="loginBox">
					<div className="loginBoxLeft">
						<div className="inputBox">
							<label htmlFor="userEmail">電子信箱</label>
							<input className="inputControl" type="email" placeholder="請輸入電子信箱" name="userEmail" id="userEmail" value={this.state.userEmail} onChange={(event) => this.handleUserInput(event)} />
							{this.validator.message('Email', this.state.userEmail, 'required|email','invalidInput',{required: '必填!', default: '信箱格式不正確。.'})}
						</div>
						<div className="inputBox">
							<label htmlFor="userPassword">密碼</label>
							<input className="inputControl" type="password" placeholder="請輸入密碼" name="userPassword" id="userPassword" value={this.state.userPassword} onChange={(event) => this.handleUserInput(event)} />
							{this.validator.message('Password', this.state.userPassword, 'required','invalidInput',{required: '必填!', default: '密碼不正確。'})}
						</div>
						<div className="inputBox">
							<Recaptcha
							    sitekey="6LfzdC8UAAAAAKi5PRuEkPDyrWnRkI0UKDmS2J_9"
							    render="explicit"
							    verifyCallback={this.verifyCallback}
							    onloadCallback={this.callback}
							    expiredCallback={this.expiredCallback}
							    hl={"zh-TW"}
							/>
							<input type="hidden" name="recaptcha" value={this.state.recaptcha} />
							{this.validator.message('VaildCode', this.state.recaptcha, 'required','invalidInput',{required: '請先勾選。'})}
						</div>
						{this.showErrorMessage(login_error)}
						<button className="loginSubmitBtn" onClick={this.submitForm}>登入</button>
					</div>
					{/*<div className="loginBoxRight">
						<div className="iconWrapper">
							<div className="bigProfileIcon"></div>
						</div>
						<div className="fbLoginBtn" onClick={this.handleClick}><span className="sprite4 sprite-icon-fb-btn"></span>A腐B帳號</div>
						<div className="fbLoginBtn" onClick={this.handleSkip} style={{marginTop: '15px'}}><span className="sprite4 sprite-icon-fb-btn"></span>跳過登入</div>
					</div>*/}
				</div>
			</div>
		)
	}
}

function mapStateToProps({ bgSetting,login,login_isloading,login_error }) {
  return {bgSetting,login,login_isloading,login_error}
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ fetch_login }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./src/containers/login.js